export const SKIP_EXCEPTION_TYPES = ['case_import_hash']
